import React from "react";
import ReactDOM from "react-dom";
import { autorun } from "mobx";
import { Provider } from "mobx-react";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";

import "./index.css";

import App from "./App";
import RootStore from "./models/RootStore";
import GAListener from "./components/GAListener";
import UiStore, { UiStoreContext } from "./stores/UiStore";

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

// Set up the MST store
const rootStore = RootStore.create({});

// Bootstrap with a saved token if we have one
const token = window.sessionStorage.getItem('api_token');
if (token !== null) {
  rootStore.authStore.bootstrap(token);
}

// Set up the MST AuthStore to persist to sessionStorage
autorun(() => {
  const user = rootStore.authStore.user;
  if (user) {
    window.sessionStorage.setItem('api_token', user.token);
  } else {
    window.sessionStorage.removeItem('api_token');
  }
});

// Set up app with Provider to pass rootStore around
const app = (
  <UiStoreContext.Provider value={ new UiStore() }>
    <Provider rootStore={rootStore}>
      <BrowserRouter>
        <GAListener>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <App />
          </MuiPickersUtilsProvider>
        </GAListener>
      </BrowserRouter>
    </Provider>
  </UiStoreContext.Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
